module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-Australia-Website-w720.e02534d1.jpg";